import { mainnet, sepolia } from 'viem/chains';

export const getTokenNetwork = () => {
  return process.env.REACT_APP_ENVIRONMENT === 'development'
    ? sepolia
    : mainnet;
};
